import axios from 'axios'

const api = axios.create({
  baseURL: `${process.env.REACT_APP_HOST}/wp-json/wp/v2`,
})

export default api
